import { createContext } from 'react';

import { AllPairedCostAdjustmentSummaryTypes } from '../types.js';

export const PairedCostAdjustmentSummaryModalContext = createContext<{
  pairedCostModal: AllPairedCostAdjustmentSummaryTypes | null;
  setPairedCostModal: (val: AllPairedCostAdjustmentSummaryTypes | null) => void;
}>({
  pairedCostModal: null,
  setPairedCostModal: () => null,
});
